import React, { useEffect, useRef } from "react";
import { googleSession } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export const AuthCallback = () => {
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      try {
        if (sessionId) {
          const data = await googleSession(sessionId);
          setUser(data.user);
        }
      } catch (e) {
        // ignore, fall through to home
      } finally {
        window.history.replaceState(null, "", "/");
        window.location.replace("/");
      }
    };
    run();
  }, [setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-sand">
      <Loader2 size={36} className="animate-spin text-clay" />
      <p className="mt-4 text-ink/60 font-display text-lg">Signing you in...</p>
    </div>
  );
};
